import { SVGAttributes } from "react";

const EcosystemIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.26795 1.36133C6.03775 0.0279921 7.96225 0.0279951 8.73205 1.36133L13.0622 8.86133C13.832 10.1947 12.8697 11.8613 11.3301 11.8613H2.66987C1.13027 11.8613 0.168022 10.1947 0.937822 8.86133L5.26795 1.36133Z"
        fill="#CFB2FF"
      />
      <circle cx="18" cy="6.36133" r="5" fill="#FFA686" />
      <rect
        x="5"
        y="13.4316"
        width="10"
        height="10"
        rx="2"
        transform="rotate(-45 5 13.4316)"
        fill="#FFDF86"
      />
    </svg>
  );
};

export default EcosystemIcon;
